// Global popup module
// - Opens on page load if not previously dismissed
// - Writes a cookie keyed by popupId so changing the ID invalidates the cache

let initialized = false;
let modalEl = null;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
}

function setCookie(name, value, days = 7) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value}; ${expires}; path=/; SameSite=Lax`;
}

function getPopupId() {
  if (!modalEl) return null;
  const id = modalEl.getAttribute('data-popup-id') || '';
  return (id || '').toString().trim();
}

function getCookieKey() {
  const id = getPopupId();
  const base = 'globalPopupDismissed';
  return id ? `${base}_${id}` : base;
}

function openPopup() {
  if (!modalEl) return;
  document.body.classList.add('modal-open');
  modalEl.setAttribute('aria-hidden', 'false');
}

function closePopup({ persist = true } = {}) {
  if (!modalEl) return;
  modalEl.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('modal-open');
  if (persist) {
    setCookie(getCookieKey(), '1', 7);
  }
}

function bindControls() {
  if (!modalEl) return;
  const overlay = modalEl.querySelector('.popup-modal__overlay');
  const closeBtn = modalEl.querySelector('.popup-modal__close');
  if (overlay) {
    overlay.addEventListener('click', () => closePopup());
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', () => closePopup());
  }
  document.addEventListener('keydown', (e) => {
    const isOpen = modalEl && modalEl.getAttribute('aria-hidden') === 'false';
    if (!isOpen) return;
    if (e.key === 'Escape') {
      closePopup();
    }
  });
}

export default function initGlobalPopup() {
  if (initialized) return;
  modalEl = document.getElementById('global-popup');
  if (!modalEl) {
    return;
  }
  bindControls();
  const cookieKey = getCookieKey();
  const dismissed = cookieKey && getCookie(cookieKey) === '1';
  if (!dismissed) {
    // Slight delay to allow initial layout/animations to complete
    window.requestAnimationFrame(() => {
      openPopup();
    });
  }
  initialized = true;
}

